module.exports = __webpack_public_path__ + "static/media/35.d0a1e0c2.png";